import Review from "../types/Review";
import styles from "./ReviewItem.module.css";

// Import source icons
import starSVG from "../assets/icons/star.svg";
import userPlaceholderSrc from "../assets/icons/user1.svg"; // A single fallback placeholder

// We've removed the other user placeholders for simplicity

export const ReviewItem = (review: Review) => {
  const profileImageElement = (
    <img
      src={userPlaceholderSrc}
      alt={`Profile of ${review.name}`}
      referrerPolicy="no-referrer"
    />
  );

  // Generate star elements based on the rating
  const stars = Array.from({ length: review.stars }, (_, i) => (
    <img key={i} src={starSVG} alt="star" className={styles.star} />
  ));

  // Choose the source icon and link based on the 'source' prop

  return (
    // The entire item is now a div, and only the icon links out
    <div className={styles.review}>
      <div className={styles.reviewProfile}>
        <div className={styles.profilePic}>{profileImageElement}</div>
        <div className={styles.reviewHeader}>
          <span className={styles.reviewerName}>{review.name}</span>
        </div>
      </div>
      <div className={styles.reviewAndStars}>
        <div className={styles.reviewDate}>{review.date}</div>
        <div className={styles.stars}>{stars}</div>
      </div>
      <div className={styles.reviewComment}>{review.comment}</div>
    </div>
  );
};
